var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M13.705 2.021a1.43 1.43 0 00-1.651 1.171 1.436 1.436 0 001.163 1.663 7.099 7.099 0 014.624 2.941c2.269 3.24 1.496 7.735-1.725 10.019s-7.69 1.506-9.96-1.735c-1.959-2.797-1.641-6.524.553-8.961l.038.811A1.43 1.43 0 008.24 9.3c.282-.014.542-.108.756-.26.386-.274.629-.734.606-1.243L9.45 4.454a2.14 2.14 0 00-.697-1.494 2.116 2.116 0 00-1.542-.563l-3.325.155a1.435 1.435 0 00-1.363 1.503 1.432 1.432 0 001.494 1.37l.384-.019C1.5 8.82 1.132 13.904 3.82 17.736c3.179 4.537 9.434 5.627 13.942 2.43 4.51-3.197 5.593-9.49 2.415-14.026a9.933 9.933 0 00-6.472-4.119z"
  })));
}
export default SvgLarge;